module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    attrs: {
      "flat": _vm.flat,
      "dark": _vm.dark
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('title')) + "\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "error",
    on: {
      "click": function($event) {
        _vm.showDeleteDialog = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.delete')) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        _vm.showRescheduleDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.reschedule')))])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('delete-recurring-appointment-form', {
    on: {
      "close": function($event) {
        _vm.showDeleteDialog = false
      }
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showRescheduleDialog),
      callback: function($$v) {
        _vm.showRescheduleDialog = $$v
      },
      expression: "showRescheduleDialog"
    }
  }, [_c('reschedule-recurring-appointment-form', {
    on: {
      "close": function($event) {
        _vm.showRescheduleDialog = false
      }
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-302d3e76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/RecurringAppointmentForm.vue
// module id = 1378
// module chunks = 9